/* import { StrictMode } from 'react'; */
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { RedlineProvider } from '@libs/redline';
import { SHProvider } from '@libs/creditkit';
import { DogxProvider } from '@libs/dogx';
import { AdsProvider } from '@libs/ads';
import { WebBridgeProvider } from '@libs/app-bridge';
import { identityApi } from '@common/apis/identity/identityApi';

import App from './App';
import { createRedline } from 'redline-client-sdk';
import handlePreloadError from '@libs/utils/helpers/handlePreloadError';
import { CustomExperienceService, RenegQueryProvider } from '@libs/renegkit';
import getRedlineAppName from '@common/helpers/getRedlineAppName';

import ErrorBoundary from '@common/components/ErrorBoundary';

import { AuthenticationProvider } from '@libs/acp/contexts/Authentication';

import { addLog } from '@common/helpers/acLogsDB';

window.addEventListener('vite:preloadError', handlePreloadError);
window.addEventListener('logout_trail', async (event) => {
  const detail = event as CustomEvent<Record<string, unknown>>;
  await addLog({
    type: 'logout_trail',
    ...detail.detail,
  });
});

const redlineAppName = getRedlineAppName();

const acCreateRedline = createRedline({
  writeKey: import.meta.env.VITE_REDLINE_WRITE_KEY,
  mode: import.meta.env.VITE_ENV,
  logs: false,
  domain: 'ac',
  appName: redlineAppName,
  appVersion: import.meta.env.VITE_DEPLOY_VERSION,
});

const cpCreateRedline = createRedline({
  writeKey: import.meta.env.VITE_ENV === 'prod' ? '67d0862e-c6dd-4c9b-af98-958815952b10' : '26566c23-2e31-44f9-bc93-1ba5593238c2',
  mode: import.meta.env.VITE_ENV,
  logs: false,
  appName: import.meta.env.VITE_REDLINE_APP_NAME,
  appVersion: import.meta.env.VITE_DEPLOY_VERSION,

  /* nativeEvents: true, */
});

const rl = import.meta.env.VITE_CUSTOM_BUILD ? cpCreateRedline : acCreateRedline;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const shBaseURL = import.meta.env.VITE_SORTING_CREDIT_API_URL;

const shouldDisableAds = CustomExperienceService.getLeadsCustomExperience();
const IS_CUSTOM_BUILD = import.meta.env.VITE_CUSTOM_BUILD;
const BRAND = IS_CUSTOM_BUILD ? 'cp' : 'ac';

root.render(
  <RenegQueryProvider>
    <RedlineProvider instance={rl} appName={redlineAppName}>
      <WebBridgeProvider apiInstance={identityApi} brand={BRAND}>
        <DogxProvider>
          <SHProvider
            appName="ac"
            mode={import.meta.env.VITE_ENV}
            debug={false}
            shKey={import.meta.env.VITE_SORTING_HAT_API_KEY}
            baseURL={shBaseURL}
            identifier="userDocument"
          >
            <AdsProvider disableAds={shouldDisableAds}>
              <ErrorBoundary>
                <BrowserRouter>
                  <AuthenticationProvider>
                    <App />
                  </AuthenticationProvider>
                </BrowserRouter>
              </ErrorBoundary>
            </AdsProvider>
          </SHProvider>
        </DogxProvider>
      </WebBridgeProvider>
    </RedlineProvider>
  </RenegQueryProvider>
);
